<template>
    <div class="content" :class="visible ? 'content--visible' : ''">
        <h2>Time and Money</h2>
        <p>
            <strong>How does travel time proximity to the CBD affect the cost of living?</strong>
        </p>
        <p>When a housing cost dimension* is applied to travel-time-ranked postcodes, we can observe the relationship across the city. We can see how travel proximity to the CBD affects the cost of living – and to what extent.</p>
        <p>Living proximate to (or within) the CBD generally appears to be accompanied by higher housing costs. However the price difference between areas of similar proximity can be significant – for instance, Fairfield average rental cost is over $100 higher than neighbouring Ivanhoe.</p>
        <p>
            <small>*Median two bedroom apartment/flat weekly rental</small>
        </p>
        <p>Select a single postcode to follow through the journey.</p>
        <multiselect
            class="postcode__selector"
            :value="selectedPostcode"
            :options="data"
            track-by="postcode"
            label="label"
            @input="update_selected_postcode"
        ></multiselect>
        <br>
        <br>
    </div>
</template>

<script>
import tooltip_mixin from "@/assets/tooltip_mixin";

export default {
    props: {
        visible: {
            default: () => false
        }
    },
    mixins: [tooltip_mixin]
};
</script>

<style scoped>
.postcode__selector {
    width: 80%;
}
</style>
